export default __webpack_public_path__ + "static/media/ireland3.5069aefc.jpg";